/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('sortEditorComponent', [
  '$translate',
  function ($translate) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./sort-editor-component.html'),

      replace: true,

      link($scope) {
        $scope.onRecordsChange = (value) => {
          $scope.component.fields = value;
        };
      },
    };
  },
]);
